import type { Messages } from '../shape';

export const viewsRich = {} satisfies Messages['viewsRich'];
